import { ChangesDetection } from "../../../../change-detection";
import { I_CameraResponse } from "../api/camera.response";
import { I_StreamsResponse } from "../api/streams.response";

export class C_Camera extends ChangesDetection {

    stream?:string;
    streams?: I_StreamsResponse;
    ptz?: boolean;
    driver?:string;
    ip?: string;
    username?: string; 
    password?: string;

    constructor(json?: I_CameraResponse) {
        super();
        if (!json) return;
        if (json.stream) this.stream = json.stream;
        if (json.streams) this.streams = json.streams;
        if (json.ptz) this.ptz = json.ptz;
        if (json.driver) this.driver = json.driver;
        if (json.ip) this.ip = json.ip;
        if (json.username) this.username = json.username;
        if (json.password) this.password = json.password;
    }

}